export const swipeCode = {
  hy: [
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Տարիներ առաջ հիմնեցի փոքրիկ ատամբանուժարան, ժամանակ անց հասկացա, որ մեր օրերում կարևոր է նաև ունենալ կայք, որտեղ կլինի ամբողջական ինֆորմացիա կլինիկայի ծառայությունների մասին։ Մի քանի օրում ստացա պատրաստի կայքը, որում երևում էին մատուցած բոլոր ծառայությունները։ Շնորհակալ եմ կայքի արագ տրամադրման և բարեհամբույր սպասարկման համար։ Դեռևս որևէ խնդիր չեմ ունեցել կայքի հետ կապված, աշխատում է անխափան։",
      img: "../../img/swiper1.jpg",
      user: "Թամարա Մկրտչյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Վաղուց ցանկանում էի սովորել front-end ծրագրավորում, սակայն երկար ժամանակ չէր ստացվում գտնել ինձ համապատասխան կազմակերպություն, որին կվստահեմ ուսումս։ Վերջնական որոշումս կանգ առավ WebsitePro.am-ի խմբային օնլայն դասընթացի վրա։ Վստահաբար կարող եմ խորհուրդ տալ բոլորին մասնակցել դասընթացին, քանի որ դասընթացը շատ հագեցած էր, ամեն ինչ բացատրվում էր շատ մանրակրկիտ, իսկ դասընթացավարը շատ համբերատար ու փորձառու էր։ Դասընթացի վերջում ստացա սերտիֆիկատ, որի միջոցով այսօր աշխատում եմ բավականին հեռանկարային կազմակերպությունում։ Շնորհակալ եմ սրտացավ մոտեցման և հետաքրքիր դասընթացի համար։",
      img: "../../img/swiper2.jpg",
      user: "Արսեն Խաչատրյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Ցանկանում եմ շնորհակալություն հայտնել WebsitePro.am-ի թիմին պրոֆեսիոնալ կազմակերպված օնլայն դասընթացի համար։ Մեծ հետաքրքրությամբ եմ մասնակցել բոլոր դասերին, դասընթացավարի պրոֆեսիոնալ մոտեցման շնորհիվ արագ հաղթահարել եմ սկզբնական դժվարությունները և հունի մեջ ընկել։ Դասընթացը գնահատում եմ 10/10։",
      img: "../../img/swiper3.jpg",
      user: "Լուսինե Կիրակոսյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Իմ խանութի վեբ կայքի պատրաստման հարցով դիմել եմ WebsitePro.am-ին։ Կայքն ամբողջությամբ այնպիսին է, ինչպես միշտ պատկերացրել եմ։ Շնորհակալ եմ համբերատարության և մանրակրկիտ աշխատանքի համար։ Ընթացքում կատարվող փոփոխությունները կատարվել են շատ արագ և արդարացրել սպասումներս։",
      img: "../../img/swiper4.jpg",
      user: "Էրիկ Բադալյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Երբ պլանավորում էի նշանադրության արարողությունս, տեղյակ չէի հրավիրատոմսի վեբ տարբերակի գոյության մասին։ Տեսնելով մի քանի տարբերակ, սկզբում կարծում էի, որ հրավիրատոմսերը պատրաստվում  են զուտ վիզուալ գեղեցկության համար։ Պատվիրեցի իմ հրավիրատոմսն ու հասկացա, որ գեղեցկությունից զատ նաև հեշտացնում է հրավիրելու պրոցեսը։ Խնայածս ժամանակը հրավերների վրա, ծախսեցի առավել կարևոր նախապատրաստական աշխատանքների վրա։ Մասնակցության մասին ճշգրիտ ինֆորմացիան ստանում էի mail-ի ու տելեգրամի միջոցով։ Շնորհակալ եմ 2 օրում նման գեղեցիկ հրավիրատոմս պատրաստելու և մանրուքների հանդեպ մեծ ուշադրության համար։",
      img: "../../img/swiper5.jpg",
      user: "Միլենա Վարդանյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Շնորհակալ եմ Ձեր բարեհամբույր թիմին՝ արագ ու հաճախորդակենտրոն սպասարկման համար։ Անհրաժեշտության դեպքում հաստատ նորից կդիմեմ ձեզ։",
      img: "../../img/swiper6.jpg",
      user: "Նանե Հայրապետյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Ավարտել եմ ծրագրավորման կուրսը հենց այստեղ և շատ գոհ եմ ստացածս գիտելիքներից։ Անգամ դասընթացի ավարտից հետո շարունակում եմ կապ պահել և տարբեր մասնագիտական հարցերով դիմել դասախոոսին։ Դասընթացը խորհուրդ եմ տվել բոլոր հետաքրքրվող ընկերներիս ու ծանոթներիս։",
      img: "../../img/swiper7.jpg",
      user: "Գագիկ Աբգարյան",
    },
    {
      title: "Հաճախորդի մեկնաբանություն",
      desc: "Պատվիրել եմ օնլայն հրավիրատոմս մեր կազմակերպության կորպորատիվի համար, ստացել եմ այն մոտ 2 օրում։ Ընթացքում կապի մեջ եմ եղել մասնագետի հետ և մանրամասն ներկայացրել ցանկություններս։ Զարմանքս մեծ էր, երբ տեսա վերջնական արդյունքը, քանի որ չէի սպասում, որ կստանամ հղումը նման ճշգրտությամբ։ Ներառել ենք այս կազմակերպությունը մշտական գործընկերների ցանկում և անպայման նորից կհամագործակցենք։",
      img: "../../img/swiper8.jpg",
      user: "Սարգիս Ներսիսյան",
    },
  ],
  en: [
    {
      title: "Customer's feedback",
      desc: "Years ago, I founded a small dental clinic, and over time I realized that nowadays it is also important to have a website, where there will be complete information about the clinic's services. In a few days, I received a ready-made website, which showed all the services provided. Thank you for the quick provision of the website and friendly service. I have not had any problems with the website yet, it works smoothly.",
      img: "../../img/swiper1.jpg",
      user: "Tamara Mkrtchyan",
    },
    {
      title: "Customer's feedback",
      desc: "I have long wanted to learn front-end programming, but for a long time I could not find a suitable organization to which I would entrust my studies. My final decision was to stop at the group online course of WebsitePro.am. I can confidently recommend everyone to participate in the course, because the course was very rich, everything was explained very thoroughly, and the trainer was very patient and experienced. At the end of the course, I received a certificate, thanks to which I now work in a rather promising organization. Thank you for the caring approach and interesting course.",
      img: "../../img/swiper2.jpg",
      user: "Arsen Xachatryan",
    },
    {
      title: "Customer's feedback",
      desc: "I would like to thank the WebsitePro.am team for the professionally organized online course. I participated in all the lessons with great interest, thanks to the professional approach of the trainer, I quickly overcame the initial difficulties and got into the swing of things. I rate the course 10/10.",
      img: "../../img/swiper3.jpg",
      user: "Lusine Kirakosyan",
    },
    {
      title: "Customer's feedback",
      desc: "I contacted WebsitePro.am to prepare a website for my store. The website is exactly as I had always imagined. Thank you for your patience and thorough work. The changes made during the process were made very quickly and met my expectations.",
      img: "../../img/swiper4.jpg",
      user: "Erik Badalyan",
    },
    {
      title: "Customer's feedback",
      desc: "When I was planning my engagement ceremony, I was not aware of the existence of a web version of the invitation card. After seeing several options, at first I thought that invitation cards were made purely for visual beauty. I ordered my invitation card and realized that in addition to beauty, it also simplifies the invitation process. The time I saved on invitations, I spent on more important preparatory work. I received accurate information about participation via email and telegram. Thank you for preparing such a beautiful invitation in 2 days and for your great attention to detail.",
      img: "../../img/swiper5.jpg",
      user: "Milena Vardanyan",
    },
    {
      title: "Customer's feedback",
      desc: "Thank you to your friendly team for your fast and customer-oriented service. I will definitely contact you again if necessary",
      img: "../../img/swiper6.jpg",
      user: "Nane Hayrapetyan",
    },
    {
      title: "Customer's feedback",
      desc: "I completed the programming course here and am very satisfied with the knowledge I received. Even after the course, I continue to stay in touch and contact the tutor with various professional questions. I have recommended the course to all my interested friends and acquaintances",
      img: "../../img/swiper7.jpg",
      user: "Gagik Abgaryan",
    },
    {
      title: "Customer's feedback",
      desc: " I ordered an invitation card online for our organization’s corporate event, and I received it in about 2 days. During the process, I was in touch with a specialist and presented my wishes in detail. I was very surprised when I saw the final result, because I did not expect to receive the link with such accuracy. We have included this organization in the list of permanent partners and will definitely cooperate again",
      img: "../../img/swiper8.jpg",
      user: "Sargis Nersisyan",
    },
  ],
  ru: [
    {
      title: "Отзыв  клиента",
      desc: "Много лет назад я основала небольшую стоматологическую клинику, и со временем поняла, что в наше время также важно иметь веб-сайт, где будет полная информация об услугах клиники. Через несколько дней я получил готовый сайт, на котором были отображены все предоставляемые услуги. Спасибо за быстрое предоставление сайта и дружелюбное обслуживание. У меня пока не возникло никаких проблем с сайтом, он работает гладко.",
      img: "../../img/swiper1.jpg",
      user: "Тамара Мкртчян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Я давно хотел изучить фронтенд-программирование, но долго не мог найти подходящую организацию, которой бы доверил свое обучение. Мое окончательное решение остановилось на групповом онлайн-курсе WebsitePro.am. Я могу с уверенностью рекомендовать всем пройти курс, так как курс был очень насыщенным, все было объяснено очень подробно, а тренер был очень терпеливым и опытным. По окончании курса я получил сертификат, благодаря которому теперь работаю в довольно перспективной организации. Спасибо за заботливый подход и интересный курс.",
      img: "../../img/swiper2.jpg",
      user: "Арсен Хачатрян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Хочу выразить благодарность команде WebsitePro.am за профессионально организованный онлайн-курс. Я с большим интересом участвовала во всех занятиях, благодаря профессиональному подходу тренера я быстро преодолела первоначальные трудности и вошла в курс дела. Я оцениваю курс 10 из 10.",
      img: "../../img/swiper3.jpg",
      user: "Лусине Киракосян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Я обратился вWebsitePro.am, чтобы подготовить сайт для моего магазина. Сайт именно такой, каким я его всегда себе представлял. Спасибо за ваше терпение и тщательную работу. Изменения, внесенные в ходе процесса, были выполнены очень быстро и соответствовали моим ожиданиям.",
      img: "../../img/swiper4.jpg",
      user: "Эрик Бадалян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Когда я планировала церемонию помолвки, я не знала о существовании веб-версии пригласительного билета. Посмотрев несколько вариантов, я сначала подумала, что пригласительные открытки созданы исключительно для визуальной красоты. Я заказала пригласительный билет и поняла, что помимо красоты он еще и упрощает процесс приглашения. Время, сэкономленное на приглашениях, я потратил на более важную подготовительную работу. Точную информацию об участии я получил по электронной почте и телеграмме. Спасибо за подготовку такого прекрасного приглашения за 2 дня и за ваше огромное внимание к деталям.",
      img: "../../img/swiper5.jpg",
      user: "Милена Варданян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Спасибо вашей дружной команде за быстрое и клиентоориентированное обслуживание. При необходимости я обязательно обращусь к вам снова.",
      img: "../../img/swiper6.jpg",
      user: "Нане Айрапетян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Я закончил здесь курс программирования и очень доволен полученными знаниями. Даже после окончания курса я продолжаю поддерживать с преподавателем связь и обращаться к нему по различным профессиональным вопросам. Я рекомендовал этот курс всем своим заинтересованным друзьям и знакомым.",
      img: "../../img/swiper7.jpg",
      user: "Гагик Абгарян",
    },
    {
      title: "Отзыв  клиента",
      desc: "Я заказал онлайн пригласительный билет на корпоративное мероприятие нашей организации и получил его примерно через 2 дня. В ходе процесса я общался со специалистом и подробно изложил свои пожелания. Я был очень удивлен, когда увидел окончательный результат, так как не ожидал получить ссылку с такой точностью. Мы включили данную организацию в список постоянных партнеров и обязательно будем сотрудничать снова.",
      img: "../../img/swiper8.jpg",
      user: "Саргис Нерсисян",
    },
  ],
};
